import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import BackgroundImageCst from "@components/BackgroundImageCst";
import HeroCst from "@components/HeroCst";
import { useFetchDetail } from "@hooks/useFetchDetail";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import ActivityFormCst from "../ActivityFormCst";
import { ServicesURL, downloadFile } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import useSWRMutation from "swr/mutation";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { isTrueValue } from "@utils/utilsValidators";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useAddActivity } from "@hooks/hookscatalog/Activity/useAddActivity";
import { ColumnInterface } from "@components/Table/types";

const AddActivities: React.FC = () => {
  const { t } = useTranslation(["activities-page"]);
  // const { columns } = useFetchDetail(
  // 	ServicesURL.getPaths.replace(":idCorporate", id || ""),
  //   idLO,
  // 	PagesID["corporate.catalog.activities"]
  // );
  // const { trigger } = usePostDetail('/api/groups');
  const navigate = useNavigate();
  const { id, idLO } = useParams();

  const { onSubmit, openToast, setOpenToast, columns } = useAddActivity(
    PagesID["catalog.activities"],
    id,
  );

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-activities.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("add.hero-title")}
          description={t("add.hero-description")}
        />
        <Box
          sx={{
            mt: "25px",
          }}
        >
          <ActivityFormCst
            row={{
              self_enrollment: "false",
              flag_authentication: "false",
              is_link_relative: "false",
            }}
            columns={columns.filter((col: any) => {
              return ![
                "actual_package_version",
                "available_package_version",
                "update_package",
              ].includes(col.accessorKey);
            })}
            onSubmit={onSubmit}
            backButton={() => {
              navigate(`/corporate/${id}/detail/catalog/activities`);
            }}
          />
        </Box>
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-add")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default AddActivities;
